/**
 * To enable the view use data-view="form". Please note that the form view needs to have is root on a form element.
 * example:
 * <form class="component" data-view="form"></form>
 */
(function (ws, win) {
    'use strict';
    ws.views.form = ws.views.googleAnalytics.extend({
        errorClass: 'error',
        errorMsg: '.required-error-message',
        customErrorMsg: '.custom-required-error-message',
        customPasswordComplexityMsg: '.password-complexity-message',
        hasChanged: false,

        /**
         * Function to call during every form submission
         * that does not have errors; gets called
         * after required avalidation.
         */
        additionalValidation: undefined,

        /**
         * If this is true, the additionalValidation method (if it exists)
         * gets called during the form validation process even if
         * there are errors on the form already; if false, cancels the call
         * to additionalValidation if standard form validation fails.
         */
        additionalValidationOnErrors: false,

        /**
         * events
         */
        events: {
            'click [type="submit"]': 'checkRequired',
            'change .error': 'resetField',
            'change :input': 'formChanged',
            'keyup :input': 'formChanged',
            'keyup textarea': 'formChanged'
        },

        /**
         * Initialize
         */
        initialize() {
            this.textarea = this.$('textarea');
            this.textarea.bind('scroll', this.scrollFix);
            this.$actionSelect = this.$('.order-action-select');
            this.error = false;
            this.$actionButton = this.$('.qut-take-action');
            this.$globalmessage = $('#globalMessages');
            this.$optionalFields = this.$('.optional');
            this.orderNumber = $('.order-meta-data').data('order-number');
            this.eventAgg.on('runRulesModalTrigger', this.runRulesModalTrigger.bind(this));
            this.eventAgg.on('checkErrorAndSubmitFromStore', this.submitForm.bind(this));
            this.eventAgg.on('submitFormAfterRunRuleOE', this.submitFormAfterRunRule, this);
            this.eventAgg.on('getCustomerDispute', this.getCustomerDispute.bind(this));
            if (this.showSaveAlert === true) {
                this.openPageAlert();
            }

            this.shipToContactCompletnessTriggered = false;
            this.eventAgg.on('submitFormByContactCompletenessCheck', this.submitFormByContactCompletenessCheck, this);
            window.isCustomerDisputeComputedOnce = false;
            $(document).on('click', '.confirm-customer-dispute', () => {
                this.confirmCustomerDispute();
            });
        },

        /**
         * Update formChanged flag to reflect form has changed fields
         */
        formChanged() {
            this.hasChanged = true;
        },

        /**
         * Checks if the required fields have values for the mandatory elements
         * @param {Object} ev
         * @param {bool} skipValidation
         */
        checkRequired(ev, skipValidation) {
            //This method could be called programatically, without an event
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }

            win.onbeforeunload = null;
            $('#globalMessages').hide();
            this.$('.error-message').hide();

            var mandatoryFieldSelectors = [
                'input.validHiddenRequired',
                'input.mandatory:visible',
                'select.mandatory:visible',
                'select.mandatory.select2-hidden-accessible:enabled',
                'textarea.mandatory:visible',
                'checkbox.mandatory:visible'
            ];
            var $mandatoryFields = this.$(mandatoryFieldSelectors.join(','));
            this.error = false;
            $('.aws-tab-detail .error-message').show();
            $('.aws-tab-detail .error-message').removeAttr('style');
            $('.aws-tab-detail .error-message').addClass('hidden');
            $('.aws-generic-error-message').text('').addClass('hidden');
            $('.tab-title .aws').removeClass('error');
            if ($('#awsmarketplace').is(':checked') && ['SUBMIT_SEND', 'SUBMIT', 'SUBMIT_MULTI_CURRENCY', 'SUBMIT_SEND_MULTI_CURRENCY', 'SUBMIT_SEND_AWS_NOTIFICATION'].includes($('.sqm-select-action').val())) {
                this.eventAgg.trigger('checkForAWSMandatoryFields', false, true);
                if ($('.tab-title .aws').hasClass('error')) {
                    this.error = true;
                }
            }

            if (skipValidation !== true) {
                this.checkEmptyFields($mandatoryFields);
                if (typeof this.additionalValidation === 'function' && (this.additionalValidationOnErrors || this.error === false)) {
                    this.additionalValidation(ev);
                }
            }

            this.checkErrorAndSubmit();
        },

        /**
         * Checks if the optional fields have values when they need to be validated
         */
        checkOptional() {
            var $optionalFields = this.$('input.optional:visible, select.optional:visible, textarea.optional:visible, checkbox.optional:visible');
            this.error = false;

            this.checkEmptyFields($optionalFields);
            this.checkErrorAndSubmit();
        },

        /**
         * validates empty fields inside a field collection
         *
         * @param {jQuery} $fields
         */
        checkEmptyFields($fields) {
            _.each($fields, function (field) {
                var $field = $(field);
                if (($.trim($field.val()) === '' && $field.closest('fieldset').prop('disabled') !== true && $field.prop('disabled') !== true) || (!$field.prop('checked') && $field[0].type === 'checkbox')) {
                    this.error = true;
                    this.handleError($field, 'defaultError');
                }

            }.bind(this));
        },

        /**
         * check if all optional fields are empty
         */
        allEmptyOptionalFields() {
            return this.$optionalFields.filter(function () {
                    return $.trim($(this).val()).length !== 0;
                }).length === 0;
        },

        /**
         * checks if form has errors and submit or handle the error
         */
        checkErrorAndSubmit() {
            if (this.error === true) {
                this.hasError();
            } else {
                this.submitForm();
            }
        },

        /**
         * Handle showing errors for inputs
         *
         * @param {jQuery} $field
         * @param {string} errorType
         */
        handleError($field, errorType) {
            var errorMsg = (errorType === 'customError') ? this.customErrorMsg : this.errorMsg;

            if (errorType === 'customErrorPassword') {
                errorMsg = this.customPasswordComplexityMsg;
            }

            this.$globalmessage.hide();

            $field.addClass(this.errorClass);

            //As select2 plugin overrides the dom of select dropdown, to scroll the user error place adding error class
            if ($field.is('select')) {
                $field.closest('.select-style-autocomplete').find('.select2-selection__rendered, .select2-selection').addClass(this.errorClass);
            }

            this.checkRequiredTab($field);
            this.checkRequiredSection($field);
            $field.nextAll(errorMsg).show();
        },

        /**
         * Validates all phone numbers in the form.
         */
        checkPhone() {
            //Select all visible phone fields for validation
            var $phoneFields = this.$('input.phone:visible');
            var phone;
            var isPhoneValid;
            var $field;

            $.each($phoneFields, function (i, field) {
                $field = $(field);
                phone = $field.val();
                if (phone.length > 0) {
                    isPhoneValid = globals.validatePhoneNumber(phone);
                    if ($field.parents('fieldset').is(':enabled') && $field.is(':enabled') && !isPhoneValid) {
                        this.error = true;
                        this.handleError($field, 'customError');
                    }
                }
            }.bind(this));
        },

        /**
         * Validate all date fields in the form.
         */
        checkDate() {
            var $dateFields = this.$('input.dateField');
            var dateField;
            var isDateValid;
            var $field;

            $.each($dateFields, function (i, field) {
                $field = $(field);
                dateField = $field.val();
                if (dateField.length > 0) {
                    isDateValid = globals.validateDate(dateField);
                    if ($field.closest('fieldset').is(':enabled') && $field.is(':enabled') && !isDateValid) {
                        this.error = true;
                        this.handleError($field, 'customError');
                    }
                }
            }.bind(this));
        },

        /**
         * Validate all email addresses in the form.
         */
        checkEmail() {
            var $emailFields = this.$('input.email');
            var email;
            var isEmailValid;
            var $field;

            $.each($emailFields, function (i, field) {
                $field = $(field);
                email = $field.val();
                isEmailValid = globals.validateEmail(email);
                if (isEmailValid === false && $field.closest('fieldset').prop('disabled') !== true && $field.prop('disabled') !== true) {
                    this.error = true;
                    this.handleError($field, 'customError');
                }
            }.bind(this));
        },

        /**
         * If the form element has a contenteditable-form class,
         * checks for all inputs elements with data-hidden-input attributes
         * and sets the value of those elements to be
         * the value of the data-hidden-input attribute.
         * Submits the form.
         */

        /**
         * Form submit event handler - check for contenteditable fields and fill in their hidden counterparts values.
         */
        submitForm() {
            this.submitFormByContactCompletenessCheck();
        },

        submitFormByContactCompletenessCheck: function (isSubmit) {
            if ($('#enableContactValidation').val() === 'true' && ($('.order-action-select').val() === '4' || isSubmit) && $('.comp-order-details-tabs .error:visible').length === 0) {
                $('.submitFormWithoutValidating').unbind('click');
                $('.submitFormWithoutValidating').on('click', () => {
                    this.submitFormWithoutContactValidation();
                });

                let contactData = $('#shipToContact option:selected').data('json');

                if (!this.shipToContactCompletnessTriggered) {
                    if (contactData.accountNumber === '') {
                        this.shipToContactCompletnessTriggered = true;
                        this.eventAgg.trigger('shipToContactCompletnessTrigger');
                        $('.contact-completeness-check .heading').html('Ship-to contact is missing; do you still want to continue and submit Order?');
                        this.eventAgg.trigger('shiptocontactCompletenessCheck');
                        globals.enableApp();
                        return;
                    }

                    if (contactData.accountNumber) {
                        let selectedItems = ['email', 'firstName', 'lastName', 'phone'];
                        let properItemNames = ['Email', 'First name', 'Last name', 'Phone numbers'];
                        let incompleteArray = [];
                        selectedItems.forEach((elem) => {
                            if (contactData[elem] === null || contactData[elem].trim() === '') {
                                incompleteArray.push(properItemNames[selectedItems.indexOf(elem)]);
                            }
                        });

                        if (incompleteArray.length) {
                            this.shipToContactCompletnessTriggered = true;
                            this.eventAgg.trigger('shipToContactCompletnessTrigger');
                            $('.contact-completeness-check .heading').html(`Ship-to contact ${incompleteArray.join(', ')} ${incompleteArray.length > 1 ? 'are' : 'is'} missing; do you still want to continue and submit Order?`);
                            this.eventAgg.trigger('shiptocontactCompletenessCheck');
                            globals.enableApp();
                            return;
                        } else {
                            this.submitFormByMakingMdmCheck(true);
                        }
                    } else {
                        this.submitFormByMakingMdmCheck(true);
                    }
                } else {
                    this.submitFormByMakingMdmCheck(true);
                }
            } else {
                this.submitFormByMakingMdmCheck();
            }
        },

        submitFormWithoutContactValidation: function () {
            this.submitFormByMakingMdmCheck(true);
        },

        submitFormByMakingMdmCheck: function (isSubmit) {
            if (($('.order-action-select').val() === '4' || isSubmit) && $('.comp-order-details-tabs .error:visible').length === 0 && ($('#enableAddressValidation').val() === 'true' || $('#enableMDMTrilliumAddressValidation').val() === 'true')) {
                let sameAsShipTo = $('#endUserAddressSameAsShipToAddress').prop('checked') ? true : false;
                $('.shipToAddress').removeClass('address-error-border');
                $('.endUserAddress').removeClass('address-error-border');

                if (($('.ship-to-account .address-id').val() || $('.end-user-account .address-id').val() || sameAsShipTo)) {
                    const model = new Backbone.Model();
                    model.url = globals.path.api.orderentry.mdmAddressError.replace('{orderNumber}', this.orderNumber);

                    model.fetch({
                        data: {
                            sameAsShipTo: sameAsShipTo
                        }
                    }).done((response) => {
                        if (sameAsShipTo && Object.keys(response).length && response[Object.keys(response)[0]] && response[Object.keys(response)[0]].error) {
                            globals.enableApp();
                            let messageArray = response[Object.keys(response)[0]].errors;

                            $('.shipToAddress').addClass('address-error-border');
                            this.eventAgg.trigger('appendErroMessagesOnAddress', 'comp-account-details.ship-to-account', messageArray);
                            $('.endUserAddress').addClass('address-error-border');
                            this.eventAgg.trigger('appendErroMessagesOnAddress', 'comp-account-details.end-user-account', messageArray);
                            this.eventAgg.trigger('animateTotab', 'comp-order-shipping-details');

                            return;
                        } else if (Object.keys(response).length) {
                            if ((response.shipToAddress && response.shipToAddress.error) || (response.endCustomerAddress && response.endCustomerAddress.error)) {
                                globals.enableApp();

                                if (response.shipToAddress && response.shipToAddress.error) {
                                    $('.shipToAddress').addClass('address-error-border');
                                    this.eventAgg.trigger('appendErroMessagesOnAddress', 'comp-account-details.ship-to-account',  response.shipToAddress.errors);
                                    this.eventAgg.trigger('animateTotab', 'comp-order-shipping-details');
                                }

                                if (response.endCustomerAddress && response.endCustomerAddress.error) {
                                    $('.endUserAddress').addClass('address-error-border');
                                    this.eventAgg.trigger('appendErroMessagesOnAddress', 'comp-account-details.end-user-account', response.endCustomerAddress.errors);
                                    this.eventAgg.trigger('animateTotab', 'comp-order-shipping-details');
                                }

                                return;
                            }

                            this.submitFormAfterCustomerDispute();
                        } else {
                            $('.shipToAddress').removeClass('address-error-border');
                            $('.endUserAddress').removeClass('address-error-border');

                            this.submitFormAfterCustomerDispute();
                        }
                    }).fail (() => {
                        this.submitFormAfterCustomerDispute();
                    });
                } else {
                    this.submitFormAfterCustomerDispute();
                }
            } else {
                this.submitFormAfterCustomerDispute();
            }
        },

        submitFormAfterCustomerDispute: function () {
            if ($('#isRuleEngineCall').val() != 'true' && !window.isCustomerDisputeComputedOnce && isOrderEntrySite && ![true, 'true'].includes($('#salesBlockedForRuleValidations').val())) {
                this.getCustomerDispute(this);
            } else {
                this.submitFormAfterRunRule();
            }
        },

        submitFormAfterRunRule: function() {
            if (($('#XSSValidationEnabled').val() === true || $('#XSSValidationEnabled').val() === 'true') && !isOrderEntrySite) {
                let encryptedQuoterequester = globals.encodeString($('#quoterequester').val());
                let encryptedShippingInstruction = globals.encodeString($('#shippingInstruction').val());
                if (!$('#quoterequester').hasClass('encoded')) {
                    $('#quoterequester').val(encryptedQuoterequester);
                    $('#quoterequester').addClass('encoded');
                }

                if (!$('#shippingInstruction').hasClass('encoded')) {
                    $('#shippingInstruction').val(encryptedShippingInstruction);
                    $('#shippingInstruction').addClass('encoded');
                }
            }

            if (this.$el.hasClass('contenteditable-form')) {
                this.$('[data-hidden-input]').each(function (index, el) {
                    var $el = $(el);
                    var $input = this.$('[' + $el.data('hiddenInput') + ']');
                    $input.val($el.html());
                }.bind(this));
            }

            if ([true, 'true'].includes($('#salesBlockedForRuleValidations').val()) && $('#isRuleEngineCall').val() === 'false') {
                this.$el.submit();
            }

            if ($('.landedCostDetails').val() === 'true' || $('.retriggerLandedCost').val() === 'true') {
                globals.enableApp();
                this.eventAgg.trigger('landedCostDetailsWarningModal');
            } else if ($('#isRuleEngineCall').val() === 'true') {
                let fraudulantApi = new ws.models.quoteFraudulentModalModel();
                fraudulantApi.fetch().done((response) => {
                    globals.enableApp();
                    if (response) {
                        this.eventAgg.trigger('qut-fraudulent-modal');
                    } else if ([true, 'true'].includes($('#salesBlockedForRuleValidations').val())) {
                        this.$el.attr('action', window.location.href + '/');
                        globals.disableApp();
                        this.$actionSelect.val(4);
                        $('#isRuleEngineCall').attr('value', 'false');
                        this.eventAgg.trigger('submitOrderForm');
                        this.$actionSelect.val(0);
                    } else if (!window.isCustomerDisputeComputedOnce && isOrderEntrySite) {
                        this.getCustomerDispute(this);
                    } else {
                        this.eventAgg.trigger('runRulesModalData');
                        this.$el.attr('action', window.location.href + '/');
                    }
                }).fail (() => {
                    globals.enableApp();
                    this.eventAgg.trigger('runRulesModalData');
                    this.$el.attr('action', window.location.href + '/');
                });
            } else if ($('#hasCreditLine').val() !== 'true' && $('.mergeQuote').val() !== 'true' && $('.dealID').val() && $('.vendorQuoteId').val() && ['SUBMIT_SEND', 'SUBMIT_SEND_MULTI_CURRENCY'].includes(this.$el.find('.sqm-select-action').val()) && this.$el.find('#modalCheckDone').val() === 'false') {
                let collectionApi = new ws.collections.vrfTableCollection();
                collectionApi.quoteId = $('#quoteCode').val();
                globals.disableApp();
                collectionApi.fetch().done((response) => {
                    globals.enableApp();
                    if (response.isMultiConfigApplicable) {
                        this.eventAgg.trigger('submitAndEmailMultiConfigView');
                    } else {
                        if ($('.sqm-select-action').val() && $('.sqm-select-action').val().length && isQuotingSite && $('#quoteSubmitAjax').val() === 'true' && !['CLAIM_RFQ', 'SUBMIT_UNCLAIM_RFQ', 'INCOMPLETIONLOG'].includes($('.sqm-select-action').val())) {
                            this.eventAgg.trigger('formSubmissionWithAPI');
                        } else {
                            this.$el.submit();
                        }
                    }
                }).fail (() => {
                    globals.enableApp();
                    if ($('.sqm-select-action').val() && $('.sqm-select-action').val().length && isQuotingSite && $('#quoteSubmitAjax').val() === 'true' && !['CLAIM_RFQ', 'SUBMIT_UNCLAIM_RFQ', 'INCOMPLETIONLOG'].includes($('.sqm-select-action').val())) {
                        this.eventAgg.trigger('formSubmissionWithAPI');
                    } else {
                        this.$el.submit();
                    }
                });
            } else if (this.$el.find('.mergeQuote').val() === 'true' && this.$el.find('.sqm-select-action').val() === 'SUBMIT_SEND' && this.$el.find('#modalCheckDone').val() === 'false') {
                this.eventAgg.trigger('submitAndEmailMergeQuoteModal');
                globals.enableApp();
            } else {
                if ($('#configurator-id').length) {
                    $('#configurator-id').remove();
                }

                if ($('.sqm-select-action').val() && $('.sqm-select-action').val().length && isQuotingSite && $('#quoteSubmitAjax').val() === 'true' && !['CLAIM_RFQ', 'SUBMIT_UNCLAIM_RFQ', 'INCOMPLETIONLOG'].includes($('.sqm-select-action').val())) {
                    this.eventAgg.trigger('formSubmissionWithAPI');
                } else {
                    this.$el.submit();
                }
            }
        },

        populateCustomerDisputeModal: function () {
            const columnData = window.handsOnTableCopy.getDataAtProp('warehouseList');
            const warehouseList = [...new Set(columnData.filter(value => value !== null && value !== undefined && value !== ''))];
            $('.cdm-reseller-name').text(`${$('.soldTo .account-name-text').text()} (${$('.soldTo .sapId').val()})`);
            $('.cdm-total-exc-vat').text(`${$('.total-exc-vat').text()}`);
            $('.cdm-total-vat').text(`${$('.totalTax').text()}`);
            $('.cdm-total-price').text(`${$('.totalPrice').text()}`);
            $('.cdm-currency').text(`${$('#currency').val()}`);
            let shippingAddressContainer = $('.component.comp-account-details.ship-to-account');
            let newShippingContainer = $('<div></div>').addClass('new-ship-to-account-container');
            shippingAddressContainer
                .find('div')
                .not('.select-from-ajax-address-search, .hide')
                .clone()
                .appendTo(newShippingContainer);
            $('.cdm-shipping-address').empty().append(newShippingContainer);
            let billingAddressContainer = $('.component.comp-account-details.ship-to-account');
            let newBillingContainer = $('<div></div>').addClass('new-ship-to-account-container');
            billingAddressContainer
                .find('div')
                .not('.select-from-ajax-address-search, .hide')
                .clone()
                .appendTo(newBillingContainer);
            $('.cdm-warehouse').text(warehouseList.join(','));
            $('.cdm-billing-address').empty().append(newBillingContainer);
            $('.cdm-part-shipment').text($('#partShipment').is(':checked') ? 'Yes' : 'No');
            $('.cdm-vat-reg-no').text($('.vatRegNoChange').find('span').text());
        },

        getCustomerDispute: _.debounce(function (el) {
            let self = el;
            let countryCode = $('.component.comp-account-details.ship-to-account').find('span[data-name="Country"]').text();
            let url = globals.path.api.orderentry.orderDetails.getCustomerDispute.replace('{orderNumber}', this.orderNumber) + `?salesoffice=${$('#salesOffice').val()}&totalprice=${$('.totalPrice').data('value')}&shiptoaddresscountry=${countryCode}`;
            this.populateCustomerDisputeModal();
            globals.disableApp();
            $.ajax({
                url: url,
                contentType: 'application/json',
                method: 'GET'
            }).done((response) => {
                globals.enableApp();
                window.isCustomerDisputeComputedOnce = true;
                $('.customer-dispute-modal .error').html('').css('display', 'none');
                let errorMessage = '';
                if (response.messageList && response.messageList.length) {
                    response.messageList.forEach((msg) => {
                        errorMessage += `${msg} <br>`;
                    });

                    $('.customer-dispute-modal .error').html(errorMessage).css('display', 'block');
                    self.eventAgg.trigger('customerDisputeModal');
                } else {
                    if (self && typeof self.confirmCustomerDispute === 'function') {
                        self.confirmCustomerDispute();
                    } else {
                        this.confirmCustomerDispute();
                    }
                }
            }).fail((e) => {
                globals.enableApp();
                console.log('error', e);
            });
        }, 1000),

        confirmCustomerDispute: function () {
            this.submitFormAfterRunRule();
        },

        runRulesModalTrigger: function () {
            this.eventAgg.trigger('runRulesModalData');
            this.$el.attr('action', window.location.href + '/');
        },

        /**
         * openPageAlert
         */
        openPageAlert() {
            /**
             * Open alert if user navigates away from page without saving changes
             * @returns {string}
             */
            win.onbeforeunload = function () {
                if (this.hasChanged) {
                    return 'You have made some changes to the below form';
                }
            }.bind(this);
        },

        /**
         * Scrolls the page to the first visible error.
         * And enable app if it's disabled.
         */
        hasError() {
            globals.enableApp();

            // Because this method can be called multiple times
            // (likely due to spaghetti coding), use isShowingError
            // to determine whether or not we're in the middle
            // of showing an error, and skip out if we are.
            if ($('.error:visible').length > 0 && !this.isShowingError) {
                this.isShowingError = true;
                $('html, body').animate({
                    scrollTop: $('.error:visible:first').offset().top - 200
                }, 700, 'swing', () => {
                    this.isShowingError = false;
                });
            }
        },

        /**
         * Check if input is in a tab and handle error on tab label if yes
         * @param {jQuery} $field
         */
        checkRequiredTab($field) {
            var $tabContent = $field.closest('.content');
            if ($tabContent.length !== 0) {
                $('[href="#' + $tabContent.prop('id') + '"]').addClass(this.errorClass);
                this.hasError();
            }
        },

        /**
         * Sets the active tab to the one the current field is located in,
         * then scrolls the page to it.
         *
         * @param {jQuery} $field
         */
        checkRequiredSection($field) {
            var $containerSection = $field.closest('.tab');
            if ($containerSection.length !== 0) {
                $('.tab').removeClass('active');
                $containerSection.addClass('active');
                $('ul.tabs-headers li button.tab-header').removeClass('active');
                $('ul.tabs-headers li').eq($containerSection.index()).children('button.tab-header').addClass('active');
                this.hasError();
            }
        },

        /**
         * Reset field with error message
         * @param {Object} e
         */
        resetField(e) {
            var $el = $(e.currentTarget ? e.currentTarget : e);
            $el.removeClass(this.errorClass);

            //As select2 plugin overrides the dom of select dropdown, to scroll the user error place removing error class
            if ($el.is('select')) {
                $el.closest('.select-style-autocomplete').find('.select2-selection__rendered, .select2-selection').removeClass(this.errorClass);
            }

            $el.nextAll(this.errorMsg).hide();
            $el.nextAll(this.customErrorMsg).hide();
        },

        /**
         * Removes all error messages from the page,
         * and clears all elements as being erroneous.
         */
        clearValidation() {
            $('.error').removeClass('error');
            $(this.errorMsg).hide();
            $(this.customErrorMsg).hide();
        },

        /**
         * Validate password Complexity.
         */
        checkPasswordComplexity() {
            var $passwordField = this.$('input.passwordComplexity');
            let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})');
            if (strongPassword.test($passwordField.val())) {
                this.error = false;
            } else {
                this.error = true;
                this.handleError($passwordField, 'customErrorPassword');
            }
        }
    });
})(westcon, window);
